import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class IPAPIService {
  constructor(private httpClient: HttpClient, private router: Router) {}

  private countries: string[] = ['na'];

  async get() {
    const ipAddress: any = await this.httpClient
      .get('http://api.ipify.org/?format=json')
      .toPromise();

    const ipapi: any = await this.httpClient
      .get(`https://ipapi.co/${ipAddress.ip}/json`)
      .toPromise();

    const country = ipapi.country;

    if (this.countries.find((x) => x == (country as string).toLowerCase())) {
      this.router.navigate([(country as string).toLowerCase()]);
    }
  }
}
